import 'whatwg-fetch'

import {LOCAL_PREFIX} from 'services/api'

import productsDetailEan from './products/detailEan'
import productsDetailExt from './products/detailExternal'

const useFakeApi = true // process.env.NODE_ENV !== 'production'

export const faker = (input, init) => {
  if (useFakeApi) {
    const str = input.split(LOCAL_PREFIX)[1]
    let data

    switch (true) {
      case /\/products\/detail\?ean=/.test(str):
        data = productsDetailEan
        break
      case /\/products\/detail\?externalId=/.test(str):
        data = productsDetailExt
        break
      default:
        data = false
    }

    if (data) {
      return new Promise(r => {
        setTimeout(() => {
          r({
            status: 200,
            json: () => data,
            ok: true,
          })
        }, 500)
      })
    }
  }

  return fetch(input, init)
}
